import { motion } from 'framer-motion';
import styled from 'styled-components';

import Heading from '../Heading';
import Icon from '../Icon';

interface CopyProps {
  color: string;
  fontSize?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
}

enum SizeMap {
  xsmall = '0.75rem', // 12px
  small = '0.875rem', // 14px
  medium = '1rem', // 16px
  large = '1.125rem', // 18px
  xlarge = '1.5rem', // 24px
  xxlarge = '1.875rem', // 30px
  huge = '2.875rem', // 30px
}

const Copy = styled.p<CopyProps>`
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => (fontSize ? SizeMap[fontSize] : SizeMap['medium'])};
  font-weight: 400;
  white-space: break-spaces;
`;

export const BannerWrapper = styled(motion.div)<{ backgroundUrl: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding-left: 1.75rem;
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  background-image: ${({ backgroundUrl }) => `url(${backgroundUrl})`};
  background-repeat: cover no-repeat;
  background-size: cover;
  position: relative;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
    height: fit-content;
    align-items: flex-start;
    padding-top: 1.5rem;
  }
`;

export const Title = styled(Heading)`
  font-size: ${SizeMap['huge']};
`;

export const Message = styled(Copy)`
  margin-left: 2.75rem;

  @media only screen and (max-width: 1440px) {
    font-size: 16px;
    padding-bottom: 0.5rem;
    padding-top: 1rem;
  }

  @media only screen and (max-width: 900px) {
    margin-top: 0.5rem;
    margin-left: 0;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    padding-bottom: 3.5rem;
  }
`;

export const Conditions = styled(Copy)`
  font-style: italic;
  position: absolute;
  right: 10px;
  bottom: 1px;

  @media only screen and (max-width: 900px) {
    left: 1.75rem;
    font-size: 12px;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
`;

export const IconStyle = styled(Icon)`
  cursor: pointer;
`;
